import {
	OPEN_DATA,
	BIS,
	CITYPAY,
	NYC_GOV,
	COMBINED,
	FDNY_SCRAPER,
	COUNTY_CLERK,
} from 'data/dataSourceConstants';

/* schema
	[dataSetName]: {
		urlPath: api list enpoint path (may be prefixed with data source)
		dataSet: 'dataSetName' same as key, unique id for ui side stuff
		dataSources: list of data sources for this data set, one of [OPEN_DATA, BIS, CITYPAY, NYC_GOV]
		exportName: data set name used by api excel/pdf export endpoint
		pusherDataSetNames: {
			[dataSource]: name of `datasetName` prop from pusher onUpdate notification
		},
		openIssueCountFields: {
			[dataSource]: property name of open issues count from /api/property/overview/:address endpoint
		},
		detailsUrl: api details endpoint path, if not present then its the same as urlPath
		hasStatus: if false, dataset can't be filtered on open/closed status
	},
*/

export const dataConfig = {
	complaints311: {
		urlPath: '311-complaints',
		dataSet: 'complaints311',
		dataSources: [OPEN_DATA],
		exportName: '311Complaints',
		pusherDataSetNames: {
			[OPEN_DATA]: 'TOOComplaints',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_too_complaints_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: '311 Complaints',
		},
		fileUploadName: {
			[OPEN_DATA]: 'open-data-311-complaints',
		},
	},
	dobComplaints: {
		urlPath: 'dob-complaints',
		dataSet: 'dobComplaints',
		dataSources: [OPEN_DATA, BIS],
		exportName: 'complaints',
		pusherDataSetNames: {
			[BIS]: 'BisComplaints',
			[OPEN_DATA]: 'OdDobComplaints',
		},
		openIssueCountFields: {
			[BIS]: 'open_bis_dob_complaints_count',
			[OPEN_DATA]: 'open_od_dob_complaints_count',
		},
		firstLoadTaskNames: {
			[BIS]: 'Complaints',
			[OPEN_DATA]: 'DOB Complaints',
		},
		fileUploadName: {
			[BIS]: 'bis-dob-complaints',
			[OPEN_DATA]: 'open-data-dob-complaints',
		},
	},
	dobViolations: {
		urlPath: 'dob-violations',
		dataSet: 'dobViolations',
		dataSources: [OPEN_DATA, BIS],
		exportName: 'dobViolations',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataDobViolations',
			[BIS]: 'BisDobViolations',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_dob_violations_count',
			[BIS]: 'open_bis_dob_violations_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'DOB Violations',
			[BIS]: 'BIS DOB Violations',
		},
		fileUploadName: {
			[OPEN_DATA]: 'open-data-dob-violations',
			[BIS]: 'bis-dob-violations',
		},
	},
	dobSafetyViolations: {
		urlPath: 'dob-safety-violations',
		dataSet: 'dobSafetyViolations',
		dataSources: [OPEN_DATA],
		exportName: 'dobSafetyViolations',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataDobSafetyViolations',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_dob_safety_violations_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'DOB Safety Violations',
		},
		fileUploadName: {
			[OPEN_DATA]: 'open-data-dob-safety-violations',
		},
	},
	ecbViolations: {
		urlPath: 'ecb-violations',
		dataSet: 'ecbViolations',
		dataSources: [OPEN_DATA, BIS],
		exportName: 'ecbViolations',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataEcbViolations',
			[BIS]: 'BisEcbViolations',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_ecb_violations_count',
			[BIS]: 'open_bis_ecb_violations_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'ECB Violations',
			[BIS]: 'BIS ECB Violations',
		},
		fileUploadName: {
			[OPEN_DATA]: 'open-data-ecb-violations',
			[BIS]: 'bis-ecb-violations',
		},
	},
	jobApplications: {
		urlPath: 'job-applications',
		dataSet: 'jobApplications',
		dataSources: [OPEN_DATA, BIS],
		exportName: 'jobApplications',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataJobApplications',
			[BIS]: 'BisJobApplications',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_job_applications_count',
			[BIS]: 'open_bis_job_applications_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'Job Applications',
			[BIS]: 'BIS Job Applications',
		},
		hasStatus: false,
		fileUploadName: {
			[OPEN_DATA]: 'open-data-job-applications',
			[BIS]: 'bis-job-applications',
		},
	},
	dobPermitIssuances: {
		urlPath: 'permit-issuances',
		dataSet: 'permitIssuances',
		dataSources: [OPEN_DATA],
		exportName: 'dobPermitIssuances',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataDobPermitIssuances',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_od_dob_permit_issuances_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'DOB Permit Issuances',
		},
		detailsUrl: 'dob-permit-issuances',
		fileUploadName: {
			[OPEN_DATA]: 'open-data-permit-issuances',
		},
	},
	approvedPermits: {
		urlPath: 'approved-permits',
		dataSet: 'approvedPermits',
		dataSources: [OPEN_DATA],
		exportName: 'dobNowBuildApprovedPermits',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataDobNowBuildApprovedPermits',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_od_dob_now_build_approved_permits_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'DOB Now Build - Approved Permits',
		},
		fileUploadName: {
			[OPEN_DATA]: 'open-data-approved-permits',
		},
	},
	certificatesOfOccupancy: {
		urlPath: 'cos',
		dataSet: 'certificatesOfOccupancy',
		dataSources: [OPEN_DATA],
		exportName: 'dobCOs',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataCertificatesOfOccupancy',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_od_dob_cos_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'DOB C/Os',
		},
		fileUploadName: {
			[OPEN_DATA]: 'open-data-cos',
		},
	},
	dobJobApplications: {
		urlPath: 'dob-now-build-job-application-filings',
		dataSet: 'dobJobApplications',
		dataSources: [OPEN_DATA],
		exportName: 'dobNowBuildJobApplicationFilings',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataDobNowJobApplicationFilings',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_od_dob_now_build_job_application_filings_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'DOB Now Build - Job Application Filings',
		},
		fileUploadName: {
			[OPEN_DATA]: 'open-data-dob-now-build-job-application-filings',
		},
	},
	dobNowSafetyFacades: {
		urlPath: 'facade-filings',
		dataSet: 'dobNowSafetyFacades',
		dataSources: [OPEN_DATA],
		exportName: 'facadeFilings',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataFacadeFilings',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_od_dob_now_safety_facades_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'DOB Now - Facades',
		},
		fileUploadName: {
			[OPEN_DATA]: 'open-data-facade-filings',
		},
	},
	bisIlluminatedSigns: {
		urlPath: 'illuminated-signs',
		dataSet: 'bisIlluminatedSigns',
		dataSources: [BIS],
		exportName: 'bisIlluminatedSigns',
		pusherDataSetNames: {
			[BIS]: 'BisIlluminatedSigns',
		},
		openIssueCountFields: {
			[BIS]: 'expired_bis_illuminated_signs_count',
		},
		firstLoadTaskNames: {
			[BIS]: 'BIS Illuminated Signs',
		},
		hasStatus: true,
	},
	dobNowSafetyBoilers: {
		urlPath: 'boilers',
		dataSet: 'dobNowSafetyBoilers',
		dataSources: [OPEN_DATA],
		exportName: 'boilers',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataBoilers',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_od_dob_now_safety_boilers_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'DOB Now - Safety Boilers',
		},
		fileUploadName: {
			[OPEN_DATA]: 'open-data-boilers',
		},
	},
	bisBoilers: {
		urlPath: 'boilers',
		detailsUrl: 'bis/boilers',
		dataSet: 'bisBoilers',
		dataSources: [BIS],
		exportName: 'bisBoilers',
		pusherDataSetNames: {
			[BIS]: 'BisBoilers',
		},
		openIssueCountFields: {
			[BIS]: 'open_bis_boilers_count',
		},
		firstLoadTaskNames: {
			[BIS]: 'BIS Boilers',
		},
		fileUploadName: {
			[BIS]: 'bis-boilers',
		},
	},
	electricalPermitApplications: {
		urlPath: 'electrical-permit-applications',
		dataSet: 'electricalPermitApplications',
		dataSources: [OPEN_DATA],
		exportName: 'electricalPermitApplications',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataElectricalPermitApplications',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_od_dob_now_electrical_permit_applications_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'DOB Now - Electrical Permit Applications',
		},
		fileUploadName: {
			[OPEN_DATA]: 'open-data-electrical-permit-applications',
		},
	},
	elevatorPermitApplications: {
		urlPath: 'elevator-permit-applications',
		dataSet: 'elevatorPermitApplications',
		dataSources: [OPEN_DATA],
		exportName: 'elevatorPermitApplications',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataElevatorPermitApplications',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_od_dob_now_build_elevator_permit_applications_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'Dob Now Build - Elevator Permit Applications',
		},
		fileUploadName: {
			[OPEN_DATA]: 'open-data-elevator-permit-applications',
		},
	},
	elevatorRecords: {
		urlPath: 'elevator-records',
		dataSet: 'elevatorRecords',
		dataSources: [BIS],
		exportName: 'elevatorRecords',
		pusherDataSetNames: {
			[BIS]: 'BisElevatorRecords',
		},
		openIssueCountFields: {
			[BIS]: 'bis_elevator_records_count',
		},
		firstLoadTaskNames: {
			[BIS]: 'Elevator Records',
		},
		hasStatus: false,
		fileUploadName: {
			[BIS]: 'bis-elevator-records',
		},
	},
	limitedAlterationApplications: {
		urlPath: 'limited-alteration-applications',
		dataSet: 'limitedAlterationApplications',
		dataSources: [OPEN_DATA],
		exportName: 'limitedAlterationApplications',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataLimitedAlterationApplications',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_od_dob_now_build_limited_alteration_applications_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'DOB Now Build - Limited Alteration Applications',
		},
		fileUploadName: {
			[OPEN_DATA]: 'open-data-limited-alteration-applications',
		},
	},
	hpdHousingViolations: {
		urlPath: 'hpd-housing-violations',
		dataSet: 'hpdHousingViolations',
		dataSources: [OPEN_DATA],
		exportName: 'housingViolations',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataHPDHousingViolations',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_od_hpd_housing_violations_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'HPD Housing Violations',
		},
		fileUploadName: {
			[OPEN_DATA]: 'open-data-hpd-housing-violations',
		},
	},
	housingLitigations: {
		urlPath: 'hpd-housing-litigations',
		dataSet: 'housingLitigations',
		dataSources: [OPEN_DATA],
		exportName: 'housingLitigations',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataHPDHousingLitigations',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_od_hpd_housing_litigations_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'HPD Housing Litigations',
		},
		fileUploadName: {
			[OPEN_DATA]: 'open-data-hpd-housing-litigations',
		},
	},
	sideWalkViolations: {
		urlPath: 'side-walk-violations',
		dataSet: 'sideWalkViolations',
		dataSources: [OPEN_DATA],
		exportName: 'sideWalkViolations',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataSidewalkViolations',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_sidewalk_violations_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'Check Sidewalk Violations',
		},
		detailsUrl: 'side-walk-violations',
	},
	// hpdHousingComplaints: {
	// 	urlPath: 'hpd-housing-complaints',
	// 	dataSet: 'hpdHousingComplaints',
	// 	dataSources: [OPEN_DATA],
	// 	exportName: 'housingComplaints',
	// 	pusherDataSetNames: {
	// 		[OPEN_DATA]: 'OpenDataHPDHousingComplaints',
	// 	},
	// 	openIssueCountFields: {
	// 		[OPEN_DATA]: 'open_od_hpd_housing_complaints_count',
	// 	},
	// 	fileUploadName: {
	// 		[OPEN_DATA]: 'open-data-hpd-housing-complaints',
	// 	},
	// },
	hpdComplaints: {
		urlPath: 'hpd-complaints',
		dataSet: 'hpdComplaints',
		dataSources: [OPEN_DATA],
		exportName: 'hpdComplaints',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataHPDComplaints',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_od_hpd_complaints_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'HPD Complaints (Open Data)',
		},
		fileUploadName: {
			[OPEN_DATA]: 'open-data-hpd-complaints',
		},
	},
	repairVacateOrders: {
		urlPath: 'repair-vacate-orders',
		dataSet: 'repairVacateOrders',
		dataSources: [OPEN_DATA, BIS],
		exportName: 'hpdOrdersToRepairVacate',
		pusherDataSetNames: {
			[BIS]: 'BisRepairVacateOrders',
			[OPEN_DATA]: 'OpenDataRepairVacateOrders',
		},
		openIssueCountFields: {
			[BIS]: 'vacate_stop_work_orders_count',
			[OPEN_DATA]: 'repair_vacate_orders_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'HPD Housing - Repair / Vacate Orders',
		},
		hasStatus: false,
		fileUploadName: {
			[OPEN_DATA]: 'open-data-repair-vacate-orders',
		},
	},
	stopWorkOrders: {
		urlPath: 'stop-work-orders',
		dataSet: 'stopWorkOrders',
		dataSources: [BIS],
		exportName: 'stopWorkOrders',
		pusherDataSetNames: {
			[BIS]: 'BisStopWorkOrders',
		},
		openIssueCountFields: {
			[BIS]: 'bis_stop_work_orders_count',
		},
		firstLoadTaskNames: {
			[BIS]: 'Stop Work Orders',
		},
		hasStatus: true,
		fileUploadName: {
			[BIS]: 'bis-stop-work-orders',
		},
	},
	standardsApplicationStatuses: {
		urlPath: 'standards-application-statuses',
		dataSet: 'standardsApplicationStatuses',
		dataSources: [OPEN_DATA],
		exportName: 'standardsAppealsApplications',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataStandardsApplicationStatuses',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'standards_application_statuses_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'Standards Application Statuses',
		},
		fileUploadName: {
			[OPEN_DATA]: 'open-data-standards-application-statuses',
		},
	},
	fdnyNov: {
		urlPath: 'fdny-nov',
		dataSet: 'fdnyNov',
		dataSources: [FDNY_SCRAPER],
		exportName: 'fdnyNov',
		pusherDataSetNames: {
			[FDNY_SCRAPER]: 'FdnyNovRecords',
		},
		openIssueCountFields: {
			[FDNY_SCRAPER]: 'fdny_nov_count',
		},
		firstLoadTaskNames: {
			[FDNY_SCRAPER]: 'FDNY Report',
		},
		detailsUrl: 'fdny-nov',
		fileUploadName: {
			[FDNY_SCRAPER]: 'fdny-nov-records',
		},
		hasStatus: true,
	},
	fdnyVio: {
		urlPath: 'fdny-vio',
		dataSet: 'fdnyVio',
		dataSources: [FDNY_SCRAPER],
		exportName: 'fdnyVio',
		pusherDataSetNames: {
			[FDNY_SCRAPER]: 'FdnyVioRecords',
		},
		openIssueCountFields: {
			[FDNY_SCRAPER]: 'fdny_vio_count',
		},
		firstLoadTaskNames: {
			[FDNY_SCRAPER]: 'FDNY Report',
		},
		detailsUrl: 'fdny-vio',
		fileUploadName: {
			[FDNY_SCRAPER]: 'fdny-vio-records',
		},
		hasStatus: true,
	},
	fdnyOathHearings: {
		urlPath: 'oath-hearings',
		dataSet: 'fdnyOathHearings',
		dataSources: [OPEN_DATA],
		exportName: 'odOathHearings',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OATH Hearings',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_od_oath_hearings_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'OATH Hearings',
		},
		detailsUrl: 'oath-hearings',
		fileUploadName: {
			[OPEN_DATA]: 'open-data-oath-hearings',
		},
	},
	ecbTicketFinderHearings: {
		urlPath: 'ecb-ticket-finder-hearings',
		dataSet: 'ecbTicketFinderHearings',
		dataSources: [OPEN_DATA],
		exportName: 'ecbTicketFinderHearings',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataEcbTicketFinderHearings',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_ecb_ticket_finder_hearings_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'OATH/ECB Hearings',
		},
		detailsUrl: 'ecb-ticket-finder-hearings',
		fileUploadName: {
			[OPEN_DATA]: 'ecb-ticket-finder-hearings',
		},
		hasStatus: true,
	},
	fdnyViolations: {
		urlPath: 'fdny/violations',
		dataSet: 'fdnyViolations',
		dataSources: [OPEN_DATA],
		exportName: 'fireActiveViolationOrders',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataFDNYViolations',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_fdny_violations_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'FDNY Violations',
		},
		detailsUrl: 'fdny-violations',
		fileUploadName: {
			[OPEN_DATA]: 'open-data-fdny-violations',
		},
	},
	fdnyInspections: {
		urlPath: 'fdny/inspections',
		dataSet: 'fdnyInspections',
		dataSources: [OPEN_DATA],
		exportName: 'fireInspections',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataFDNYInspections',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_fdny_inspections_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'FDNY Inspections',
		},
		detailsUrl: 'fdny-inspections',
		fileUploadName: {
			[OPEN_DATA]: 'open-data-fdny-inspections',
		},
	},
	// fdnyPermits: {
	// 	urlPath: 'fdny-permits',
	// 	dataSet: 'fdnyPermits',
	// 	dataSources: [NYC_GOV],
	// 	exportName: 'fireActivePermits',
	// 	pusherDataSetNames: {
	// 		[NYC_GOV]: 'OpenDataFDNYPermits',
	// 	},
	// 	openIssueCountFields: {
	// 		[NYC_GOV]: 'open_fdny_permits_count',
	// 	},
	// 	fileUploadName: {
	// 		[NYC_GOV]: 'fdny-permits',
	// 	},
	// },
	fdnyPermits2: {
		urlPath: 'fdny-permit-accounts',
		dataSet: 'fdnyPermits2',
		dataSources: [FDNY_SCRAPER],
		exportName: 'fdnyPermits2',
		pusherDataSetNames: {
			[FDNY_SCRAPER]: 'FdnyPermitAccounts',
		},
		openIssueCountFields: {
			[FDNY_SCRAPER]: 'fdny_permit_accounts_count',
		},
		firstLoadTaskNames: {
			[NYC_GOV]: 'FDNY Permits (Nyc.gov)',
			[FDNY_SCRAPER]: 'FDNY Report',
		},
		detailsUrl: 'fdny-permit-accounts',
		fileUploadName: {
			[FDNY_SCRAPER]: 'fdny-permit-accounts',
		},
		hasStatus: true,
	},
	fdnySummaries: {
		urlPath: 'fdny/summaries',
		dataSet: 'fdnySummaries',
		dataSources: [OPEN_DATA],
		exportName: 'fireSummary',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataFDNYSummaries',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'fdny_summaries_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'FDNY Summary',
		},
		detailsUrl: 'fdny-summaries',
		hasStatus: false,
		fileUploadName: {
			[OPEN_DATA]: 'fdny-summaries',
		},
	},
	citypayTickets: {
		urlPath: 'citypay-tickets',
		dataSet: 'citypayTickets',
		dataSources: [CITYPAY],
		exportName: 'citypayTickets',
		pusherDataSetNames: {
			[CITYPAY]: 'CitypayTickets',
		},
		openIssueCountFields: {
			[CITYPAY]: 'citypay_tickets_count',
		},
		firstLoadTaskNames: {
			[CITYPAY]: 'Citypay Tickets',
		},
		hasStatus: false,
		fileUploadName: {
			[OPEN_DATA]: 'citypay-tickets',
		},
	},
	taxLienSales: {
		urlPath: 'tax-lien-sales',
		dataSet: 'taxLienSales',
		dataSources: [OPEN_DATA],
		exportName: 'taxLienSales',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataTaxLienSales',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'tax_lien_sales_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'Tax Lien Sales',
		},
		hasStatus: false,
		fileUploadName: {
			[OPEN_DATA]: 'open-data-tax-lien-sales',
		},
	},
	acrisLegals: {
		urlPath: 'acris-rpls',
		dataSet: 'acrisLegals',
		dataSources: [OPEN_DATA],
		exportName: 'acrisRpls',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataAcrisRpls',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'acris_rpls_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'ACRIS Real Property Legals',
		},
		hasStatus: false,
		fileUploadName: {
			[OPEN_DATA]: 'open-data-acris-rpls',
		},
	},
	acrisDocuments: {
		urlPath: 'acris-documents',
		dataSet: 'acrisDocuments',
		dataSources: [OPEN_DATA],
		exportName: 'acrisDocuments',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataAcrisDocuments',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'acris_documents_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'ACRIS Documents',
		},
		hasStatus: false,
		detailsUrl: 'acris-documents',
		fileUploadName: {
			[OPEN_DATA]: 'open-data-acris-documents',
		},
	},
	acrisSalesTransfers: {
		urlPath: 'acris-sales-transfers',
		dataSet: 'acrisSalesTransfers',
		dataSources: [OPEN_DATA],
		exportName: 'acrisSalesTransfers',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataAcrisSalesTransfers',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'acris_sales_transfers_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'ACRIS Documents',
		},
		hasStatus: false,
		detailsUrl: 'acris-documents',
		fileUploadName: {
			[OPEN_DATA]: 'open-data-acris-documents',
		},
	},
	dobPlaceOfAssembly: {
		urlPath: 'place-of-assemblies',
		dataSet: 'dobPlaceOfAssembly',
		dataSources: [BIS],
		exportName: 'bisPlaceOfAssemblies',
		pusherDataSetNames: {
			[BIS]: 'BisPlaceOfAssemblies',
		},
		openIssueCountFields: {
			[BIS]: 'open_bis_place_of_assemblies_count',
		},
		firstLoadTaskNames: {
			[BIS]: 'Check Place of Assemblies',
		},
		hasStatus: true,
		fileUploadName: {
			[BIS]: 'bis-place-of-assemblies',
		},
	},
	// slaLiquorLicenses: {
	// 	urlPath: 'liquor-licenses',
	// 	dataSet: 'slaLiquorLicenses',
	// 	dataSources: [OPEN_DATA],
	// 	exportName: 'slaLiquorLicenses',
	// 	pusherDataSetNames: {
	// 		// [OPEN_DATA]: '',
	// 	},
	// 	openIssueCountFields: {
	// 		[OPEN_DATA]: 'liquor_licenses_count',
	// 	},
	// 	detailsUrl: 'open-data/liquor-licenses',
	// 	hasStatus: false,
	// 	fileUploadName: {
	// 		[OPEN_DATA]: 'open-data-liquor-licenses',
	// 	},
	// },
	slaLiquorLicenses: {
		urlPath: 'sla/liquor-licenses',
		dataSet: 'slaLiquorLicenses',
		dataSources: [OPEN_DATA],
		exportName: 'odSlaLiquorLicenses',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataLiquorLicenses',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'liquor_licenses_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'SLA Liquor Licenses',
		},
		detailsUrl: 'open-data/sla/liquor-licenses',
		hasStatus: false,
		fileUploadName: {
			[OPEN_DATA]: 'open-data-sla-liquor-licenses',
		},
	},
	// dosBusinessEntities: {
	// 	urlPath: 'dos-entities',
	// 	dataSet: 'dosBusinessEntities',
	// 	dataSources: [OPEN_DATA],
	// 	exportName: 'dosEntities',
	// 	pusherDataSetNames: {
	// 		[OPEN_DATA]: 'OpenDataDOSEntities',
	// 	},
	// 	openIssueCountFields: {
	// 		[OPEN_DATA]: 'od_dos_entities_count',
	// 	},
	// 	detailsUrl: 'open-data/dos-entities',
	// 	hasStatus: false,
	// 	fileUploadName: {
	// 		[OPEN_DATA]: 'open-data-dos-entities',
	// 	},
	// },
	deedRestrictions: {
		urlPath: 'deed-restrictions',
		dataSet: 'deedRestrictions',
		dataSources: [OPEN_DATA],
		exportName: 'deedRestrictions',
		pusherDataSetNames: {
			[OPEN_DATA]: 'deedRestrictions',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'od_deed_restrictions_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'Deed Restrictions',
		},
		detailsUrl: 'open-data/deed-restrictions',
		hasStatus: false,
		fileUploadName: {
			[OPEN_DATA]: 'open-data-deed-restrictions',
		},
	},
	landmarkBuildings: {
		urlPath: 'landmark-buildings',
		dataSet: 'landmarkBuildings',
		dataSources: [OPEN_DATA],
		exportName: 'landmarkBuildings',
		pusherDataSetNames: {
			[OPEN_DATA]: 'landmarkBuildings',
		},
		openIssueCountFields: {
			// [OPEN_DATA]: '', //no such thing as 'open' landmarks
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'Landmark Buildings',
		},
		detailsUrl: 'open-data/landmark-buildings',
		hasStatus: false,
		fileUploadName: {
			[OPEN_DATA]: 'open-data-landmark-buildings',
		},
	},
	// landmarkSites: {
	// 	urlPath: 'landmark-sites',
	// 	dataSet: 'landmarkSites',
	// 	dataSources: [OPEN_DATA],
	// 	exportName: 'odLandmarkSites',
	// 	pusherDataSetNames: {
	// 		// [OPEN_DATA]: 'OpenDataLandmarkSites',
	// 	},
	// 	openIssueCountFields: {
	// 		// [OPEN_DATA]: '', //no such thing as 'open' landmarks
	// 	},
	// 	detailsUrl: 'open-data/landmark-sites',
	// 	hasStatus: false,
	// 	fileUploadName: {
	// 		[OPEN_DATA]: 'open-data-landmark-sites',
	// 	},
	// },
	landmarkViolations: {
		urlPath: 'landmark-violations',
		dataSet: 'landmarkViolations',
		dataSources: [OPEN_DATA],
		exportName: 'landmarkViolations',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataLandmarkViolations',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'od_landmark_violations_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'Landmark Violations',
		},
		detailsUrl: 'open-data/landmark-violations',
		hasStatus: false,
		fileUploadName: {
			[OPEN_DATA]: 'open-data-landmark-violations',
		},
	},
	landmarkApplications: {
		urlPath: 'landmark-applications',
		dataSet: 'landmarkApplications',
		dataSources: [OPEN_DATA],
		exportName: 'landmarkApplications',
		pusherDataSetNames: {
			[OPEN_DATA]: 'OpenDataLandmarkApplications',
		},
		openIssueCountFields: {
			// [OPEN_DATA]: 'od_landmark_applications_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'Landmark Applications',
		},
		detailsUrl: 'open-data/landmark-applications',
		hasStatus: false,
		fileUploadName: {
			[OPEN_DATA]: 'open-data-landmark-applications',
		},
	},

	dobComplaintsCombined: {
		urlPath: 'dob/complaints',
		dataSet: 'dobComplaintsCombined',
		dataSources: [COMBINED],
		// exportName: 'dobComplaintsCombined',
		pusherDataSetNames: {
			// [COMBINED]: 'dobComplaintsCombined',
		},
		openIssueCountFields: {
			[COMBINED]: 'open_combined_dob_complaints_count',
		},
		// Sources this row is assembled from; its loader waits on all of their first-load tasks.
		combinedFrom: [
			{ dataSet: 'dobComplaints', dataSource: BIS },
			{ dataSet: 'dobComplaints', dataSource: OPEN_DATA },
		],
		// detailsUrl: 'dob/complaints',
		// hasStatus: false,
		fileUploadName: {
			// [COMBINED]: 'dob/complaints',
		},
	},

	dobViolationsCombined: {
		urlPath: 'dob/violations',
		dataSet: 'dobViolationsCombined',
		dataSources: [COMBINED],
		// exportName: 'dobViolationsCombined',
		pusherDataSetNames: {
			// [COMBINED]: 'dobViolationsCombined',
		},
		openIssueCountFields: {
			[COMBINED]: 'open_combined_dob_violations_count',
		},
		combinedFrom: [
			{ dataSet: 'dobViolations', dataSource: BIS },
			{ dataSet: 'dobViolations', dataSource: OPEN_DATA },
		],
		// detailsUrl: 'dob/violations',
		// hasStatus: false,
		fileUploadName: {
			// [COMBINED]: 'dob/violations',
		},
	},

	ecbViolationsCombined: {
		urlPath: 'ecb/violations',
		dataSet: 'ecbViolationsCombined',
		dataSources: [COMBINED],
		// exportName: 'ecbViolationsCombined',
		pusherDataSetNames: {
			// [COMBINED]: 'ecbViolationsCombined',
		},
		openIssueCountFields: {
			[COMBINED]: 'open_combined_ecb_violations_count',
		},
		combinedFrom: [
			{ dataSet: 'ecbViolations', dataSource: BIS },
			{ dataSet: 'ecbViolations', dataSource: OPEN_DATA },
		],
		// detailsUrl: 'ecb/violations',
		// hasStatus: false,
		fileUploadName: {
			// [COMBINED]: 'ecb/violations',
		},
	},

	// OATH/ECB Hearings shown as one dataset built from the ECB Ticket Finder
	// scrape and the Open Data OATH feed (VWA-2773). Like the other combined
	// entries it has no export, pusher name or first-load task of its own --
	// those belong to the two source datasets it is assembled from.
	oathHearingsCombined: {
		urlPath: 'oath/hearings',
		dataSet: 'oathHearingsCombined',
		dataSources: [COMBINED],
		openIssueCountFields: {
			[COMBINED]: 'open_combined_oath_hearings_count',
		},
		combinedFrom: [
			{ dataSet: 'ecbTicketFinderHearings', dataSource: OPEN_DATA },
			{ dataSet: 'fdnyOathHearings', dataSource: OPEN_DATA },
		],
		hasStatus: true,
	},

	jobApplicationsCombined: {
		urlPath: 'job-applications',
		dataSet: 'jobApplicationsCombined',
		dataSources: [COMBINED],
		// exportName: 'jobApplicationsCombined',
		pusherDataSetNames: {
			// [COMBINED]: 'jobApplicationsCombined',
		},
		openIssueCountFields: {
			[COMBINED]: 'open_combined_job_applications_count',
		},
		combinedFrom: [
			{ dataSet: 'jobApplications', dataSource: BIS },
			{ dataSet: 'jobApplications', dataSource: OPEN_DATA },
		],
		// detailsUrl: 'job-application',
		// hasStatus: false,
		fileUploadName: {
			// [COMBINED]: 'job-applications',
		},
	},

	// DOT Liens (VWA-2696): NY County Clerk / JDLS "Sidewalk Lien" book, Manhattan
	// only, refreshed by a daily operator sweep rather than a server-side scraper.
	// Several checklist fields are intentionally absent because the api does not
	// provide them yet: no exportName (no PropertyExportHandler set), no
	// pusher name (no live updates), no
	// firstLoadTaskNames (not part of first-load-tasks), no pusher name (no live
	// updates), and no fileUploadName entry (no FileController dataset mapping).
	dotLiens: {
		urlPath: 'dot-liens',
		dataSet: 'dotLiens',
		dataSources: [COUNTY_CLERK],
		hasStatus: false,
		// Manhattan only. The sidewalk lien book is indexed by the New York County
		// clerk and nowhere else, so a property in another borough is out of coverage
		// rather than clear, and the data set is hidden for it entirely.
		coveredBoroughs: [1],
		exportName: 'dotLiens',
		pusherDataSetNames: {},
		openIssueCountFields: {
			[COUNTY_CLERK]: 'open_county_clerk_filings_count',
		},
		detailsUrl: 'dot-liens',
		firstLoadTaskNames: {
			[COUNTY_CLERK]: 'DOT Liens',
		},
		fileUploadName: {
			[COUNTY_CLERK]: 'dot-liens',
		},
	},

	depEcbViolations: {
		urlPath: 'dep-ecb-violations',
		dataSet: 'depEcbViolations',
		dataSources: [OPEN_DATA],
		// exportName: 'depEcbViolations',
		pusherDataSetNames: {
			[OPEN_DATA]: 'depEcbViolations',
		},
		openIssueCountFields: {
			[OPEN_DATA]: 'open_od_dep_ecb_violations_count',
		},
		firstLoadTaskNames: {
			[OPEN_DATA]: 'DEP ECB Violations',
		},
		fileUploadName: {
			[OPEN_DATA]: 'dep-ecb-violations',
		},
		detailsUrl: 'open-data/dep-ecb-violations',
	},
};
